/* AFX · Recomendaciones del carrito v2 (1/11/2026). Las pinta snippets/afx-cart-cross-sell.liquid (hasta 6).
   Aquí: primero las de la ficha que se visita (window.__afxCsPdp), 3 a la vista, y «Añadir» sin recargar la página
   (/cart/add.js pasa por afx-cart-sync: regalos al día; el cajón llega en la misma respuesta). */
(function () {
  if (window.__AFX_CS2) return;
  window.__AFX_CS2 = true;
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function order() {
    var pdp = window.__afxCsPdp || [];
    $$('[data-afx-cross-sell] .afx-cs__list').forEach(function (list) {
      var cards = $$('[data-afx-cs-card]', list);
      if (!cards.length) return;
      var rank = function (c) {
        var i = pdp.indexOf(c.getAttribute('data-h'));
        return i < 0 ? 100 + Number(c.getAttribute('data-i') || 0) : i;
      };
      var sorted = cards.slice().sort(function (a, b) { return rank(a) - rank(b); });
      if (sorted.some(function (c, i) { return c !== cards[i]; })) sorted.forEach(function (c) { list.appendChild(c); });
      sorted.forEach(function (c, i) { var h = i >= 3; if (c.hidden !== h) c.hidden = h; });
    });
  }

  function morph(html) {
    var G = window.__afxbnGifts;
    if (G && G.morph) { G.morph(html); return; }
    var cur = document.querySelector('xo-cart-mini');
    var f = new DOMParser().parseFromString(html, 'text/html').querySelector('xo-cart-mini');
    if (cur && f) cur.innerHTML = f.innerHTML;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-afx-add]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var vid = Number(btn.getAttribute('data-variant-id'));
    if (!vid) return;
    var tx = btn.textContent;
    btn.classList.add('is-loading');
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'xo-cart-mini' })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function (d) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = '✓';
        var html = d && d.sections && d.sections['xo-cart-mini'];
        if (html) morph(html);
        try { document.dispatchEvent(new CustomEvent('afx:drawer')); } catch (x) {}
        try { (window.dataLayer = window.dataLayer || []).push({ event: 'afx_cart_xsell_add', afx_variant: vid }); } catch (x) {}
        setTimeout(order, 60);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = tx; }, 1200);
      });
  }, true);

  function watch() {
    var el = document.querySelector('xo-cart-mini');
    if (!el || el.__afxCsObs || !window.MutationObserver) return;
    el.__afxCsObs = true;
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(order, 80); }).observe(el, { childList: true, subtree: true });
  }
  document.addEventListener('afx:cart', function () { watch(); setTimeout(order, 120); });
  document.addEventListener('afx:drawer', function () { watch(); setTimeout(order, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); order(); });
  else { watch(); order(); }
})();